import React, { useState } from 'react';
import { hot } from 'react-hot-loader';

import Mapview from 'components/mapview/mapview';
import { loadEsriResources } from '../controllers/esriMapController';

import './app.scss';

const App = () => {
  const [modulesLoaded, setmodulesLoaded] = useState(false);

  loadEsriResources().then(() => {
    setmodulesLoaded(true);
  });

  return (
    <div className="container">
      {modulesLoaded && (
        <React.Fragment>
          <Mapview />
        </React.Fragment>
      )}
    </div>
  );
};

export default hot(module)(App);
